"use client";

import { type FC, type ReactNode, useMemo } from "react";
import { PubSub } from "@huub-web/utils";

import { PubSubContext } from "../../contexts";
import type { PubSubMap } from "../../types";

export type PubSubProviderProps = {
  children: ReactNode;
};

export const PubSubProvider: FC<PubSubProviderProps> = ({ children }) => {
  const pubSub = useMemo(() => new PubSub<PubSubMap>(), []);

  return (
    <PubSubContext.Provider value={pubSub}>{children}</PubSubContext.Provider>
  );
};
